module.exports = __webpack_public_path__ + "static/media/Interac.5b4248a8.svg";